export default __webpack_public_path__ + "static/media/turbineWheel.8300ba6c.png";